module.exports = __webpack_public_path__ + "static/mission-40d74740272994244fbe72c9136fdbbb.png";